
import { PiPProvider, usePiPWindow } from "../../../containers/components/pip/pip_provider"
// import PiPWindow from "../../../containers/components/pip/pip_window"
// import NewPanggilanAntrian from "./new_panggilan_antrian"
import TabDetailPemanggilan from "./tabDetailPemanggilan"

export default function MainPanggilanAntrian(props){
    return (
        <>
            <PiPProvider>
                {/* {simple != null ? <Example /> : <ExampleWithState />} */}
                {/* <h1>Isi</h1> */}
                {<TabDetailPemanggilan {...props}/>}
            </PiPProvider>
        </>
    )
}